import { BlockSize } from 'aos-helpers/src/helpers/Block'
import { TaskCategory } from 'aos-services/src/services/tasks/types/TaskCategory'
import { Icon, IconVariant } from 'aos-ui/src/components/svg/Icon'
import React, { FC } from 'react'

import { taskIcon } from '../../utils'

interface TaskIconProps {
    category: TaskCategory
    iconVariant?: IconVariant
    iconSize?: BlockSize
    color?: string
}

export const TaskIcon: FC<TaskIconProps> = ({
    category,
    iconVariant,
    iconSize = BlockSize.Std,
    color,
}) => <Icon iconSize={iconSize} svg={taskIcon[category]} iconVariant={iconVariant} color={color} />
